import React from 'react'
import userProfileIcon from '../../../../assets/icons/user-profile.svg'
import ahcLoginRedirect from '../../../../utilities/profile/accor/ahcLoginRedirect'
import cendynLoginRedirect from '../../../../utilities/profile/cendyn/cendynLoginRedirect'

const BkFlowNavigationProfileModalToggle = (props) => {
	const {
		configData,
		currentQuery
	} = props

	const hotelLabels = configData.hotel.labels[0]

	return  (
		<button
			className="bk-flow-navigation__profile-modal-toggle"
			onClick={process.env.REACT_APP_CRM_PROVIDER === 'accor' ? () => ahcLoginRedirect(currentQuery) : () => cendynLoginRedirect(currentQuery)}
		>
			<img
				src={ userProfileIcon }
				alt="Profile Login Avatar"
			/>
			<span>{ hotelLabels.signIn ? hotelLabels.signIn : 'Sign In' }</span>
		</button>
	)
}

export default BkFlowNavigationProfileModalToggle


// WEBPACK FOOTER //
// ./src/components/structure/navigation/profile/BkFlowNavigationProfileModalToggle.js